export const ESCAPE = "Escape";
export const DELETE = "Delete";
export const BACKSPACE = "Backspace";
export const ARROW_UP = "ArrowUp";
export const ARROW_DOWN = "ArrowDown";
export const ARROW_LEFT = "ArrowLeft";
export const ARROW_RIGHT = "ArrowRight";
export const ALT = "Alt";
export const SPACE = "Space";
export const COMMAND = "Command";
export const CONTROL = "Ctrl";
export const SHIFT = "Shift";
export const KEY_A = "a";
export const KEY_B = "b";
export const KEY_C = "c";
export const KEY_D = "d";
export const KEY_E = "e";
export const KEY_G = "g";
export const KEY_I = "i";
export const KEY_K = "k";
export const KEY_L = "l";
export const KEY_M = "m";
export const KEY_O = "o";
export const KEY_P = "p";
export const KEY_Q = "q";
export const KEY_T = "t";
export const KEY_U = "u";
export const KEY_V = "v";
export const KEY_W = "w";
export const KEY_X = "x";
export const KEY_Y = "y";
export const KEY_Z = "z";
export const EQUAL = "=";
export const MINUS = "-";
export const COMMA = ",";
export const PERIOD = ".";
export const FORWARD_SLASH = "/";
export const BRACKET_LEFT = "[";
export const BRACKET_RIGHT = "]";
